module.exports = {
        srcSet: __webpack_public_path__ + "assets/images/result-table-b2aa70d696e11b0c.png"+" 440w",
        images: [{path: __webpack_public_path__ + "assets/images/result-table-b2aa70d696e11b0c.png",width: 440,height: 522}],
        src: __webpack_public_path__ + "assets/images/result-table-b2aa70d696e11b0c.png",
        toString: function(){return __webpack_public_path__ + "assets/images/result-table-b2aa70d696e11b0c.png"},
        
        width: 440,
        height: 522
      }